/**
 * Revamp Cart Section — real-time cart updates for the standalone page section.
 * Mirrors MCartDrawerItems but targets the section wrapper instead of the drawer.
 *
 * Key problem: On the cart page, MCartTemplate sets isCartPage = true which
 * changes quantity selectors and event binding in ways that break our section.
 * We force isCartPage = false after super() to get drawer-style behavior.
 */
class MRevampCartSectionItems extends MCartTemplate {
  constructor() {
    super();

    // Force non-cart-page behaviour so:
    //  • updateQuantity uses #MinimogDrawer-quantity-N (our items' IDs)
    //  • onCartUpdate doesn't try to re-render via cart-template section
    this.isCartPage = false;

    // Override the loading target to this section instead of document.body / drawer
    const sectionWrapper = this.closest('.revamp-cart-section') || this;
    this.loading = new MinimogLibs.AnimateLoading(sectionWrapper, { overlay: sectionWrapper });

    // Capture-phase click listener for remove buttons.
    // MCartRemoveButton's own handler only looks for m-cart / m-cart-drawer-items
    // as a parent — it won't find m-revamp-cart-section-items and will throw.
    // By intercepting during the capture phase we stop the event before it
    // reaches the button's own listener.
    this.addEventListener('click', (event) => {
      const removeBtn = event.target.closest('m-cart-remove-button');
      if (removeBtn) {
        event.preventDefault();
        event.stopPropagation();
        this.updateQuantity(removeBtn.dataset.index, 0);
      }
    }, true);  // ← capture phase
  }

  /**
   * Called when the cart is updated externally (e.g. cross-sell add, drawer change).
   * Re-renders our section using the Section Rendering API.
   */
  onCartUpdate() {
    const { routes } = window.MinimogSettings;
    fetch(`${routes.cart}?section_id=revamp-cart-section`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.getSectionsToRender().forEach((section) => {
          const sourceEl = html.querySelector(section.selector);
          const targetEl = document.getElementById(section.id) &&
                           document.getElementById(section.id).querySelector(section.selector);
          if (sourceEl && targetEl) {
            targetEl.innerHTML = sourceEl.innerHTML;
          }
        });
      })
      .catch((e) => console.error('Revamp section cart update error:', e));
  }

  getSectionsToRender() {
    return [
      {
        id: "RevampCartSection",
        section: "revamp-cart-section",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "RevampCartSection",
        section: "revamp-cart-section",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "RevampCartSection",
        section: "revamp-cart-section",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "RevampCartSection",
        section: "revamp-cart-section",
        selector: "[data-minimog-gift-wrapping]",
      },
    ];
  }
}

customElements.define("m-revamp-cart-section-items", MRevampCartSectionItems);
